import React, { useEffect, useState } from "react";
import { useStore } from "stores/connect";
import { Spinner } from "components/common";
import StartNewForwarder from "./select-forwarder-step/StartNewForwarder";
import SelectForwarder from "./select-forwarder-step/SelectForwarder";
import ForwardersStore, { ForwardersActions } from "../stores/ForwardersStore";
let fetchInterval;
const SelectForwarderStep = ({ onStepComplete }) => {
  const [action, setAction] = useState("select");
  const { forwardersPendingConfiguration } = useStore(ForwardersStore);
  useEffect(() => {
    ForwardersActions.listPendingConfiguration({});
    fetchInterval = setInterval(() => {
      ForwardersActions.listPendingConfiguration({}, true);
    }, 10 * 1e3);
    return () => {
      if (fetchInterval) {
        clearInterval(fetchInterval);
      }
    };
  }, [action]);
  if (!forwardersPendingConfiguration) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (action === "start") {
    return /* @__PURE__ */ React.createElement(StartNewForwarder, { forwarders: forwardersPendingConfiguration, onForwarderSelect: onStepComplete });
  }
  return /* @__PURE__ */ React.createElement(
    SelectForwarder,
    {
      forwarders: forwardersPendingConfiguration,
      onForwarderSelect: onStepComplete,
      onStartForwarderClick: () => setAction("start")
    }
  );
};
export default SelectForwarderStep;
